import React from 'react';

import {
  forwardRef,
  Textarea as ChakraTextarea,
  useStyleConfig,
} from '@chakra-ui/react';

import { TextareaProps } from './types';

export const Textarea = forwardRef<TextareaProps, 'textarea'>((props, ref) => {
  const styles = useStyleConfig('Textarea', { ...props });
  // Using __css instead of `sx` to prevent conflicts with Chakra's default styles.
  // Chakra's theme sets a height for textarea, which can override height set via props if `sx` is used.
  return <ChakraTextarea ref={ref} __css={styles} {...props} />;
});
